/** Copy text to the clipboard. Resolves false instead of throwing – a denied
 * permission or an insecure context must not break the action around it. */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
